export function isSelectedTab(active,tab){
  return active!==tab?'d-none':'';
}